// Firebase Functions URLs
const LOCAL_SERVER_URL = "http://localhost:5001/my-tassel/us-central1/api";
const FIREBASE_SERVER_URL = "https://us-central1-my-tassel.cloudfunctions.net/api";

// Use the local Functions emulator when served from localhost.
// Expo web always produces NODE_ENV='production', so we check the hostname instead.
const _onLocalhost =
  typeof window !== 'undefined' &&
  (window.location?.hostname === 'localhost' || window.location?.hostname === '127.0.0.1');
const API_URL = _onLocalhost ? LOCAL_SERVER_URL : FIREBASE_SERVER_URL;

// Font families
const FONTS = {
  Bodoni72Smallcaps: "Bodoni72Smallcaps",
  OrpheusPro: "Orpheus Pro",
};

// App Theme Colors
const COLORS = {
  primary: "#4c956c", // Green
  secondary: "#fefde2", // Light Cream
  accent: "#d68c45", // Orange
  background: "#f7f7f7", // Light Gray
  text: "#333333",
  error: "#FF6B6B",
  success: "#2ecc71",
  warning: "#f1c40f",
  disabled: "#9AC5E2",
  link: "#3498db",
  white: "#ffffff",
  black: "#000000",
};

// Screen breakpoints
const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  smallDesktop: 1440,
};

// Header padding to prevent overlap with fixed HeaderBar
const HEADER_PADDING = {
  mobile: 120,
  tablet: 150,
  desktop: 180,
};

export {
  API_URL,
  LOCAL_SERVER_URL,
  FIREBASE_SERVER_URL,
  FONTS,
  COLORS,
  BREAKPOINTS,
  HEADER_PADDING,
}; 